import { ReferenceInput, ReferenceInputProps, SelectInput } from 'react-admin';
import { TurnReferencesEnum } from '@/types/turn-enums';
import { SORT_OPTIONS } from './constants';
import { helperTextSx } from './styled';

type ProviderInputProps = Partial<ReferenceInputProps> & {
  helperText?: string;
  onChange?: (...event: unknown[]) => void;
};

const ProviderInput = ({
  helperText,
  label = 'Provider',
  onChange,
  reference = TurnReferencesEnum.AdminServiceProviders,
  source = 'provider',
  ...props
}: ProviderInputProps) => {
  return (
    <ReferenceInput source={source} reference={reference} sort={SORT_OPTIONS} {...props}>
      <SelectInput
        helperText={helperText}
        label={label}
        onChange={onChange}
        optionText="name"
        optionValue="id"
        sx={helperText ? helperTextSx : undefined}
        translateChoice={false}
      />
    </ReferenceInput>
  );
};

export default ProviderInput;
